import { render, staticRenderFns } from "./AIRichText.vue?vue&type=template&id=30a93b84"
import script from "./AIRichText.vue?vue&type=script&lang=js"
export * from "./AIRichText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports